/* eslint-disable camelcase */
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import StartPage from "./StartPage";
import QuestionsPage from "./QuestionsPage";
import RecommendationsPage from "./RecommendationsPage";
import ScrollToTop from "./ScrollToTop";

export default function App() {
    return (
        <Router basename="/tractorsupply/quiz" future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<StartPage />} />
                <Route path="/questions" element={<QuestionsPage />} />
                <Route path="/recommendations" element={<RecommendationsPage />} />
            </Routes>
        </Router>
    );
}
